module.exports = __webpack_public_path__ + "static/media/image-default.578cc321.png";